import {
  RESET_PASSWORD_REQUEST_REQUEST,
  RESET_PASSWORD_REQUEST_SUCCESS,
  RESET_PASSWORD_REQUEST_FAILURE,
  RESET_RESET_PASSWORD_REQUEST_STATE,
} from "../../actionTypes/resetPasswordRequest";

export interface ResetPasswordRequestState {
  loading: boolean;
  success: boolean;
  successMessage: string | null;
  error: string | null;
}

export interface ResetPasswordRequestAction {
  type:
    | typeof RESET_PASSWORD_REQUEST_REQUEST
    | typeof RESET_PASSWORD_REQUEST_SUCCESS
    | typeof RESET_PASSWORD_REQUEST_FAILURE
    | typeof RESET_RESET_PASSWORD_REQUEST_STATE;
  payload?: string;
}

const initialState: ResetPasswordRequestState = {
  loading: false,
  success: false,
  successMessage: null,
  error: null,
};

const resetPasswordRequest = (
  state: ResetPasswordRequestState = initialState,
  action: ResetPasswordRequestAction
): ResetPasswordRequestState => {
  switch (action.type) {
    case RESET_PASSWORD_REQUEST_REQUEST:
      return { ...state, loading: true, success: false, successMessage: null, error: null };
    case RESET_PASSWORD_REQUEST_SUCCESS:
      return { ...state, loading: false, success: true, successMessage: action.payload || null, error: null };
    case RESET_PASSWORD_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        successMessage: null,
        error: action.payload || "Something went wrong",
      };
    case RESET_RESET_PASSWORD_REQUEST_STATE:
      return initialState;
    default:
      return state;
  }
};

export default resetPasswordRequest;
